import clsx from 'clsx'
import React, {useContext} from 'react'
import Text from 'react-text'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import LinkBehavior from 'components/LinkBehavior'

import {TeacherContext} from 'teacher/context'

import Lessons from '../lessons'
import AssessmentLink from 'components/AssessmentLink'

export default function Unit(props) {
  const {name, id, active, assessments} = props
  const context = useContext(TeacherContext)
    if (!id) return
    const unitId = id.substring(8)
    const expanded = context.unit == unitId
    const unitLink = context.link({unit: expanded ? undefined : unitId}, context.match.path, {preserveQuery: true})
    return (<Accordion TransitionProps={{unmountOnExit: true}} disableGutters={true} className={clsx('unit',{expanded})} key={unitId} expanded={expanded} >
      <AccordionSummary
        component={LinkBehavior} to={unitLink} 
        className={clsx('unitSummary', {expanded})}
        expandIcon={<ExpandMoreIcon />}
      >
        <span className={clsx("unitName", {expanded})}>
          {`${context.translate('unit_label')} ${unitId}: ${name}`}
        </span>
        {assessments.length > 0 && <AssessmentLink {...{...props, context}} />}
      </AccordionSummary>
      <AccordionDetails className="unitDetails">
        <Lessons />
      </AccordionDetails>
    </Accordion>)
}
